'use strict';

/**
 * The Util service is for thin, globally reusable, utility functions
 */
export const ToastrService = ['toastr', function(toastr) {
  return {
    success(msg) {
      toastr.success(msg, '');
    },
    error(msg) {
      toastr.error(msg, '', {
        extendedTimeOut: 3000,
      });
    },
    info(msg) {
      toastr.info(msg, '');
    },
    warning(msg, title = '') {
      toastr.warning(msg, title, {
        extendedTimeOut: 5000,
        timeOut: 10000
      });
    }
  };
}];
